<template>
  <div
    class="modal fade"
    id="createLoanOfficerAssignment"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createLoanOfficerAssignmentLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            class="modal-title"
            id="createLoanOfficerAssignmentLabel"
          >
            {{ $t('string.assignLoanOfficer') }}
          </h4>
        </div>
        <div class="modal-body">
          <div
            class="form-group"
            :class="{'has-error' : validations['loan_officer_id']}"
          >
            <label
              for="loanOfficer"
              class="required"
            >{{ $t('string.loanOfficer') }}</label>
            <select
              class="form-control"
              id="loanOfficer"
              v-model="params.loan_officer_id"
            >
              <option
                :value="user.id"
                :key="key"
                v-for="(user, key) in loanOfficers"
              >
                {{ user.name }}
              </option>
            </select>
            <template v-if="validations['loan_officer_id']">
              <span class="help-block">{{ validations['loan_officer_id'][0] }}</span>
            </template>
          </div>

          <div
            class="form-group"
            :class="{'has-error' : validations['product']}"
          >
            <label
              for="create_product"
              class="required"
            >{{ $t('string.product') }}</label>
            <multiselect
              v-model="params.product"
              :options="products"
              id="create_product"
              :multiple="true"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              :deselect-label="$t('string.press_enter_to_remove')"
              :select-label="$t('string.press_enter_to_select')"
              :selected-label="$t('string.multiple_select_selected')"
              :placeholder="$t('string.chooseProduct')"
              label="name"
              track-by="value"
            />
            <template v-if="validations['product']">
              <span class="help-block">{{ validations['product'][0] }}</span>
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            ref="close"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button
            type="button"
            @click="onSave"
            :disabled="isSaveWaiting"
            class="btn btn-primary"
          >
            <i
              class="fa fa-spinner fa-spin"
              v-if="isSaveWaiting"
            /> {{ $t('button.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateLoanOfficerAssignment',
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      validations: {},
      params: {
        loan_officer_id: 1,
        product: []
      },
      isSaveWaiting: false,
      loanOfficers: []
    }
  },
  methods: {
    onResetForm () {
      this.validations = {}
      this.params = {
        loan_officer_id: 1,
        product: []
      }
      this.$refs.close.click()
    },
    onSave () {
      this.isSaveWaiting = true
      this.$axios.post(this.$base_api + '/api/v4/backend/loan-officer-assignment-old-client/create', this.params)
        .then(({ data }) => {
          if (data.data) {
            this.$emit('refreshList')
            this.onResponseSuccess()
            this.onResetForm()
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    },
    getLoanOfficerList () {
      this.$axios.post(this.$base_api + '/api/v4/backend/loan-officer-assignment-old-client/loan-officer-list')
        .then(({ data }) => {
          if (data.data) {
            this.loanOfficers = data.data
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
        .finally(() => {
          this.isSaveWaiting = false
        })
    }
  },
  mounted () {
    this.getLoanOfficerList()
  }
}
</script>

<style scoped>

</style>
